import { CardWithC4CssProps } from './CssConfig';

export const jobsConfigs = [
  {
    componentReference: 'title',
    label: 'Jobs',
    id: 'jobs-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 8,
  },

  // cards
  {
    componentReference: 'container',
    id: 'pipelines-cards-container',
    children: [
      {
        containerType: 'jobs',
        componentType: 'card',
        componentReference: 'card',
        id: 'jobs_opened',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 243,
          topLabel: 'Jobs opened',
          bottomLabel: 'JOBS',
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_opened',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'opened_jobs',
            id: 'jobs_opened',
          },
        },
      },
      {
        containerType: 'jobs',
        componentType: 'card',
        componentReference: 'card',
        id: 'jobs_closed',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: 14,
          topLabel: 'Jobs closed',
          bottomLabel: 'JOBS',
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_closed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'closed_jobs',
            id: 'jobs_closed',
          },
        },
      },
      {
        containerType: 'jobs',
        componentType: 'card',
        componentReference: 'card',
        id: 'jobs_time_to_close',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: '1 Year',
          topLabel: 'Time to close',
          bottomLabel: 'TIME',
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_time_to_close',
            componentType: 'card',
            apiParam: 'card',
            unit: 'time',
            // headerKey: 'time_to_close',
            id: 'jobs_time_to_close',
            calculationType: 'avgChange',
            metricKeys: {
              numerator: 'time_to_close',
              denominator: 'closed_jobs',
            },
          },
        },
      },
      {
        containerType: 'jobs',
        componentType: 'card',
        componentReference: 'card',
        id: 'jobs_target_breached',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: 73,
          topLabel: 'Target date breached jobs',
          bottomLabel: 'JOBS',
          truncationLength: 15,
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_target_breached',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'target_breached_jobs',
            id: 'jobs_target_breached',
          },
        },
      },
    ],
  },

  //trend chart
  {
    containerType: 'jobs',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'jobs_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Job open trend',
      id: 'jobs_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [
          {
            data: [0, 20, 62, 87, 60],
            name: 'Office',
          },
          {
            data: [0, 0, 1, 3, 4],
            name: 'Hybrid',
          },
          {
            data: [0, 0, 8, 2, 2],
            name: 'Remote',
          },
        ],
      },
      chartType: 'column',
    },
    api: {
      subject_type: 'jobs',
      metadata: {
        tileKey: 'jobs_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        defaultFilters: {
          group_by_2: 'job_type',
        },
        headerKeys: [],
        id: 'jobs_trend_chart',
      },
    },
  },

  //visual chart 1 & Chart 2
  {
    componentReference: 'container',
    id: 'jobs-chart-container1',
    children: [
      {
        containerType: 'jobs',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'jobs_department_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Jobs opened by department',
          id: 'jobs_department_chart',
          chartData: {
            series: [
              {
                name: 'Exec',
                y: 59,
              },
              {
                name: 'QA',
                y: 11,
              },
              {
                name: 'GTM',
                y: 12,
              },
              {
                name: 'BE',
                y: 10,
              },
              {
                name: 'ORS Partners',
                y: 32,
              },
              {
                name: 'HDworks',
                y: 1,
              },
              {
                name: 'No department',
                y: 56,
              },
              {
                name: 'Design',
                y: 1,
              },
              {
                name: 'Product',
                y: 11,
              },
              {
                name: 'Customer Support',
                y: 1,
              },
              {
                name: 'Accessbility',
                y: 23,
              },
              {
                name: 'Marketing',
                y: 2,
              },
              {
                name: 'Home Page',
                y: 3,
              },
              {
                name: 'All departments ',
                y: 1,
              },
              {
                name: 'Platform',
                y: 9,
              },
              {
                name: 'PRODUCT',
                y: 1,
              },
              {
                name: 'FE Website',
                y: 2,
              },
              {
                name: 'Support',
                y: 2,
              },
              {
                name: 'Sales',
                y: 9,
              },
              {
                name: 'Engineering',
                y: 1,
              },
              {
                name: 'Marketing',
                y: 1,
              },
              {
                name: 'Finance',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_department_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'department',
            },
            headerKeys: [],
            id: 'jobs_department_chart',
          },
        },
      },
      {
        containerType: 'jobs',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'jobs_location_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Jobs opened by location',
          id: 'jobs_location_chart',
          chartData: {
            series: [
              {
                name: 'HQ',
                y: 69,
              },
              {
                name: 'Paris',
                y: 9,
              },
              {
                name: 'Kula India',
                y: 9,
              },
              {
                name: 'Dubai',
                y: 9,
              },
              {
                name: 'Kula Dubai',
                y: 2,
              },
              {
                name: 'HQ,kula hq final',
                y: 3,
              },
              {
                name: 'DEV Center,Kula US,Kula India',
                y: 1,
              },
              {
                name: 'DEV Center,kula hq final',
                y: 1,
              },
              {
                name: 'Kula ind office,Kula ind office 2',
                y: 1,
              },
              {
                name: 'Paris,Dubai,London,Kula ind office',
                y: 1,
              },
              {
                name: 'London',
                y: 2,
              },
              {
                name: 'No location',
                y: 56,
              },
              {
                name: 'Kula ind office',
                y: 17,
              },
              {
                name: 'HQ,Dubai,Kula India,Remote,Kula Dubai',
                y: 1,
              },
              {
                name: 'HQ,Kula US,Kula India',
                y: 1,
              },
              {
                name: 'Chennai, India,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region,Location under custom region',
                y: 1,
              },
              {
                name: 'HQ,Kula India',
                y: 1,
              },
              {
                name: 'DEV Center',
                y: 14,
              },
              {
                name: 'Data Center',
                y: 6,
              },
              {
                name: 'Remote',
                y: 4,
              },
              {
                name: 'Kula US,Kula India,Albert',
                y: 1,
              },
              {
                name: 'gani test office',
                y: 6,
              },
              {
                name: 'Kula US',
                y: 2,
              },
              {
                name: 'Kula ind office 2',
                y: 7,
              },
              {
                name: 'India',
                y: 1,
              },
              {
                name: 'HQ,Kula India,Kula India,kula hq final',
                y: 1,
              },
              {
                name: 'HQ,Juno blore',
                y: 1,
              },
              {
                name: 'Kula ind office,Kula ind office 2,kula ind office sai',
                y: 1,
              },
              {
                name: 'Kula Singapore',
                y: 1,
              },
              {
                name: 'Kula India,San Francisco,kula hq final',
                y: 1,
              },
              {
                name: 'HQ,DEV Center,kula hq final',
                y: 1,
              },
              {
                name: 'Berlin,Kula ind office,Mani test',
                y: 1,
              },
              {
                name: 'Kula ind office,Kula ind office 2,Juno blore',
                y: 3,
              },
              {
                name: 'Kula India,Ch, India',
                y: 1,
              },
              {
                name: 'kula hq final',
                y: 3,
              },
              {
                name: 'HQ,DEV Center,Indonesia',
                y: 1,
              },
              {
                name: 'HQ,Data Center,Kula Dubai',
                y: 1,
              },
              {
                name: 'DEV Center,Paris',
                y: 1,
              },
              {
                name: 'Kula India,Berlin',
                y: 1,
              },
              {
                name: 'Kula ind office,Juno blore',
                y: 1,
              },
              {
                name: 'Kula India,Kula India,Kula ind office,Kula ind office 2,Juno blore,Kula Singapore office,kula hq final',
                y: 1,
              },
              {
                name: 'India — Chennai',
                y: 1,
              },
              {
                name: 'HQ,Ch, India',
                y: 1,
              },
              {
                name: 'HQ,DEV Center,Dubai,London',
                y: 1,
              },
              {
                name: 'Juno blore',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'jobs',
          metadata: {
            tileKey: 'jobs_location_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'job_location',
            },
            headerKeys: [],
            id: 'jobs_location_chart',
          },
        },
      },
    ],
  },

  // table
  {
    containerType: 'jobs',
    componentType: 'table',
    componentReference: 'table',
    id: 'jobs_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Jobs breakdown',
      id: 'jobs_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          opened_jobs: 0,
          target_breached_jobs: 0,
          closed_jobs: 0,
          closed_without_hires: 0,
          open_time: 0,
          time_to_close: 0,
          opened_jobs_total: 248,
          opened_jobs_per: 0,
          closed_jobs_total: 24,
          closed_jobs_per: 0,
          target_breached_jobs_total: 73,
          target_breached_jobs_per: 0,
          closed_without_hires_total: 24,
          closed_without_hires_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          opened_jobs: 20,
          target_breached_jobs: 0,
          closed_jobs: 1,
          closed_without_hires: 1,
          open_time: 128669249,
          time_to_close: 17045612,
          opened_jobs_total: 248,
          opened_jobs_per: '8.1',
          closed_jobs_total: 24,
          closed_jobs_per: '4.2',
          target_breached_jobs_total: 73,
          target_breached_jobs_per: 0,
          closed_without_hires_total: 24,
          closed_without_hires_per: '4.2',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          opened_jobs: 71,
          target_breached_jobs: 41,
          closed_jobs: 11,
          closed_without_hires: 11,
          open_time: 1589350837,
          time_to_close: 25977046,
          opened_jobs_total: 248,
          opened_jobs_per: '28.6',
          closed_jobs_total: 24,
          closed_jobs_per: '45.8',
          target_breached_jobs_total: 73,
          target_breached_jobs_per: '56.2',
          closed_without_hires_total: 24,
          closed_without_hires_per: '45.8',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          opened_jobs: 92,
          target_breached_jobs: 32,
          closed_jobs: 7,
          closed_without_hires: 7,
          open_time: 1628480141,
          time_to_close: 11747010,
          opened_jobs_total: 248,
          opened_jobs_per: '37.1',
          closed_jobs_total: 24,
          closed_jobs_per: '29.2',
          target_breached_jobs_total: 73,
          target_breached_jobs_per: '43.8',
          closed_without_hires_total: 24,
          closed_without_hires_per: '29.2',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          opened_jobs: 65,
          target_breached_jobs: 0,
          closed_jobs: 5,
          closed_without_hires: 3,
          open_time: 137137478,
          time_to_close: 466860,
          opened_jobs_total: 248,
          opened_jobs_per: '26.2',
          closed_jobs_total: 24,
          closed_jobs_per: '20.8',
          target_breached_jobs_total: 73,
          target_breached_jobs_per: 0,
          closed_without_hires_total: 24,
          closed_without_hires_per: '12.5',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'jobs',
      metadata: {
        tileKey: 'jobs_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'jobs_table',
      },
    },
  },
];

export const jobsLayoutConfig = [
  {
    key: 'jobs_opened',
    x: 0,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'jobs_closed',
    x: 3,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'jobs_time_to_close',
    x: 6,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'jobs_target_breached',
    x: 9,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'jobs_trend_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'jobs_department_chart',
    x: 0,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'jobs_location_chart',
    x: 6,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'jobs_table',
    x: 0,
    y: 51,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
